// const domain = process.env.REACT_APP_API_BASE_URL;
// const port = process.env.REACT_APP_PORT;
// const fileHandlerPort = process.env.REACT_APP_FILE_HANDLER_PORT;
// const linuxDomain = "192.168.10.28";
// const linuxDomain = process.env.REACT_APP_LINUX_DOMAIN;
// const hotelDomain = process.env.REACT_APP_HOTEL_DOMAIN;
// const linuxPort = process.env.REACT_APP_LINUX_PORT;
// const hotelPort = process.env.REACT_APP_HOTEL_PORT;
// const linuxFileHandlerPort = process.env.REACT_APP_LINUX_FILE_HANDLER_PORT;

import { isTripord } from './general';

const domain = isTripord
  ? `${process.env.REACT_APP_API_TRIPORD_URL}`
  : `${process.env.REACT_APP_API_TRIPSI_URL}`;
// const fileHandlerDomain = '77.104.103.150';
const port = 3000;
// const fileHandlerPort = 3000;
// const linuxDomain = "192.168.10.28";
const linuxDomain = '172.16.1.100';
const hotelDomain = '77.104.103.150';
const linuxPort = 3002;
const hotelPort = 3001;
const linuxFileHandlerPort = 3002;
// export const serverAddress = `https://${domain}:${port}`;
export const serverAddress = domain;
export const hotelAddress = `https://${hotelDomain}:${3009}`;
export const fileHandlerUrl = domain;
export const linuxServerAddress = `https://${linuxDomain}:${linuxPort}`;
export const linuxFileHandlerUrl = `https://${linuxDomain}:${linuxFileHandlerPort}`;
export const server = {
  domain,
  port,
  serverAddress,
  linuxDomain,
  linuxPort,
  linuxServerAddress,
  fileHandlerUrl,
};
